import React, { useEffect, useState } from "react";
import { Calendar, Sparkles } from "lucide-react";
import { API_BASE_URL } from "src/config/apiBase";
import { decryptToken } from "../utils/getToken";
import { TIER_STYLES } from "../../utils/leadScore";

const CrmLeadIntelligenceCompact = ({ leadId, defaultOpen = false }) => {
  const [open, setOpen] = useState(defaultOpen);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const url = API_BASE_URL;
  const token = decryptToken("accessToken") || "";

  useEffect(() => {
    if (!open || !leadId) return;
    let cancelled = false;
    setLoading(true);
    fetch(`${url}/leads/intelligence/${leadId}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((r) => (r.ok ? r.json() : null))
      .then((res) => {
        if (!cancelled) setData(res);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [open, leadId, url, token]);

  if (!leadId) return null;

  const tierStyle = TIER_STYLES[data?.predictive?.tier] || TIER_STYLES.Cold;

  return (
    <div className="crm-intelligence-compact">
      <button
        type="button"
        className="crm-intelligence-compact__toggle"
        onClick={() => setOpen((v) => !v)}
      >
        <Sparkles size={14} />
        <span>AI insight</span>
        {data?.predictive?.tier && (
          <span className={`crm-board__tier border ${tierStyle.className}`}>
            {data.predictive.tier} · {data.predictive.probability}%
          </span>
        )}
      </button>

      {open && (
        <div className="crm-intelligence-compact__body">
          {loading && <p className="crm-insights__muted">Loading…</p>}
          {!loading && data && (
            <>
              <p className="crm-intelligence-compact__summary">{data.summary}</p>
              {data.predictedCloseDate && (
                <p className="crm-intelligence-compact__close">
                  <Calendar size={14} />
                  Est. close: {data.predictedCloseDate}
                  {data.daysToClose ? ` (~${data.daysToClose}d)` : ""}
                </p>
              )}
              <p className="crm-intelligence-compact__nba">
                <strong>Next:</strong> {data.nextBestAction}
              </p>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default CrmLeadIntelligenceCompact;
